import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextarea,{ref:"textarea",attrs:{"outlined":"","auto-grow":"","label":_vm.field.text,"hide-details":!_vm.field.editable,"disabled":!_vm.field.editable,"rules":_vm.validators,"placeholder":_vm.field.placeholder || '-'},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }